import React, { useState, useEffect } from 'preact/compat';

import Node from './Node';

export default function NodeChildren(props) {
    const { object, treeState } = props;

    // we have to observe, whether the children are finished loading.
    const [childrenLoaded, setChildrenLoaded] = useState(object.finishedLoading);

    useEffect(() => {
        // check promise that may cause a second render
        object.childrenReady().then(() => {
            setChildrenLoaded(true);
        });
    }, [object.finishedLoading]);

    const current = treeState.treeOpen && object === treeState.nextObject;

    // Collect jsx of all non-categorized children.
    const uncategorized = childrenLoaded ? object.uncategorizedChildren.map(
        (child) => (
            <Node object={child} treeState={treeState} />
        ),
    ) : null;

    // Collect jsx of all categories and their children
    const categories = childrenLoaded ? object.categories.map(
        (category) => (
            <li className="category">
                <div className="category-title">
                    { category.title }
                </div>
                <ul>
                    { category.children.map((child) => <Node object={child} treeState={treeState} />) }
                </ul>
            </li>
        ),
    ) : null;

    const loading = childrenLoaded ? null : (
        <li>
            <div className="title loading">
                Loading &hellip;
            </div>
        </li>
    );

    // Render the children or the loading information
    return (
        <ul className={`children${current ? ' current-children' : ''}`}>
            { uncategorized }
            { categories }
            { loading }
        </ul>
    );
}
